import HomeLayout from "@/Pages/Home/Layouts/HomeLayout.vue" // default Inertia layout
import axios from "axios"

import BootstrapVue from "bootstrap-vue"
import jQuery from "jquery"

import Popper from "popper.js"
import V2Datepicker from "v2-datepicker"
import Vue from "vue"
import VueScrollTo from "vue-scrollto"

import "v2-datepicker/lib/index.css" // v2 need to import css
import SentryContext from "~/components/util/SentryContext.vue" // layouts.teacher
import BookCallForm from "~components/BookCallForm.vue" // page.tutor
import ClassSummaryTable from "~components/ClassSummaryTable.vue" // teacher.dashboard, classroom
import CompleteSignupForm from "~components/CompleteSignupForm.vue" // complete_signup
import DataTable from "~components/datatable/DataTable.vue" // hither and yon
import QuoteForm from "~components/QuoteForm.vue" // unified quote form: school, homeschool, district
import DistrictAdminPage from "~components/DistrictAdminPage.vue" // district_admin.dashboard
import DistrictAdminSettings from "~components/DistrictAdminSettings.vue" // district_admin.settings
import FeedbackForm from "~components/FeedbackForm.vue" // feedback
import FreeSchoolTrialButton from "~components/FreeSchoolTrialButton.vue" // referral
import FreeTrialForm from "~components/FreeTrialForm.vue" // signup, home, pricing
import ConfirmationSent from "~components/ConfirmationSent.vue"
import GenerateReportPDFButton from "~components/GenerateReportPDFButton.vue" // overall, classroom, conference
import LeftyPopup from "~components/LeftyPopup.vue" // lefty is lord of all he surveys
import ParentConnect from "~components/ParentConnect.vue" // parent_connect
import ParentEmailManager from "~components/ParentEmailManager.vue" // students.index
import PreviewExam from "~components/PreviewExam.vue" // student_exam
import QuoteFormModal from "~components/QuoteFormModal.vue" // modal wrapper for QuoteForm
import ReportCriteriaSelector from "~components/ReportCriteriaSelector.vue" // teacher.reports.*
import ReviewExtension from "~components/ReviewExtension.vue" // extension_answer
import Sandbox from "~components/Sandbox.vue"
import SchoolAdminTeacherList from "~components/school_admin/TeacherList.vue" // school_admin.teachers FIXME: rename file
import SearchStudents from "~components/SearchStudents.vue" // district_admin.search
import WithServices from "~components/services/WithServices.vue" // damn near everywhere
import ShareEmailDialogButton from "~components/ShareEmailDialogButton.vue" // overall, classroom
import SignupForm from "~components/SignupForm.vue" // signup_form, reading.shared.top, teacher.signup
import SocialLoginButtons from "~components/SocialLoginButtons.vue" // teacher.login, various signup routes
import StudentGroups from "~components/StudentGroups.vue" // teacher.students.index
import StudentList from "~components/StudentList.vue" // teacher.students.index
import StudentLogin from "~components/StudentLogin.vue" // student.login
import StudentReportLessonScoreTable from "~components/StudentReportLessonScoreTable.vue" // teacher.reports.detailed
//// Vue components used in blade templates (view name in comment)
import AssignmentPage from "~components/teacher/assign/AssignmentPage.vue" // assign_lessons
import TeacherNavBar from "~components/teacher/common/TeacherNavBar.vue" // layouts.teacher
import FluencyGradeButton from "~components/teacher/fluency/FluencyGradeButton.vue" // scores_for_lesson
import FluencyReviewPage from "~components/teacher/fluency/FluencyReviewPage.vue" // teacher.recordings
import FluencyGoalStatus from "~components/teacher/reports/FluencyGoalStatus.vue" // detailed, detail_list
import FluencyBenchmarkGraph from "~components/teacher/reports/graphs/FluencyBenchmarkGraph.vue" // fluency_graphs
import FluencyColdHotGraph from "~components/teacher/reports/graphs/FluencyColdHotGraph.vue" // fluency_graphs
import FluencyWpmGraph from "~components/teacher/reports/graphs/FluencyWpmGraph.vue"
import ReportGraph from "~components/teacher/reports/graphs/ReportGraph.vue" // school_admin.overall, teacher.reports.parts.overall, conference
import ProgressReportTable from "~components/teacher/reports/ProgressReportTable.vue" // 7_day
import TeacherEmailSummary from "~components/TeacherEmailSummary.vue" // various guest routes
import TeacherLogin from "~components/TeacherLogin.vue" // teacher.login
import TeacherResources from "~components/TeacherResources.vue" // FIXME should be TeacherResourcesPage
import TeacherSettings from "~components/TeacherSettings.vue" // teacher.settings
import TeacherVideoPlayer from "~components/TeacherVideoPlayer.vue"
import TutorialPopup from "~components/TutorialPopup.vue" // many random places
import TutorVideoCarousel from "~components/TutorVideoCarousel.vue" // page.tutor
import VimeoPopout from "~components/VimeoPopout.vue" // page.homeschool
import VolumePricingBanner from "~components/VolumePricingBanner.vue"
import CircleChart from "~components/widgets/CircleChart.vue" // denver, research, score-gauge
import WorksheetTable from "~components/WorksheetTable.vue" // worksheets
import {initInertia} from "./inertia.js"
import {initSentry} from "./sentry.ts"
import HomeNavBar from "~components/home/HomeNavBar.vue"

// import {CSRF_TOKEN} from "@/common/utils/fetch" // not doing this anymore


window.Popper = Popper
window.jQuery = jQuery
window.$ = jQuery
window.axios = axios

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  // noinspection JSUnresolvedReference
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content
  // CSRF_TOKEN.value = token.content // something completely similar for useFetcher()
} else {
  console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token")
}

// end former bootstrap.js

//// Vue plugins

Vue.use(BootstrapVue)
Vue.use(V2Datepicker.default || V2Datepicker)
Vue.use(VueScrollTo)

//// global components used in blade templates

// Vue.component("TeacherFluencyReview", TeacherFluencyReview)
Vue.component("AssignmentPage", AssignmentPage)
Vue.component("BookCallForm", BookCallForm)
Vue.component("CircleChart", CircleChart)
Vue.component("ClassSummaryTable", ClassSummaryTable)
Vue.component("CompleteSignupForm", CompleteSignupForm)
Vue.component("DataTable", DataTable)
Vue.component("Datatable", DataTable)
Vue.component("DistrictAdminPage", DistrictAdminPage)
Vue.component("DistrictAdminSettings", DistrictAdminSettings)
Vue.component("QuoteFormModal", QuoteFormModal);
Vue.component("FeedbackForm", FeedbackForm)
Vue.component("FluencyBenchmarkGraph", FluencyBenchmarkGraph)
Vue.component("FluencyColdHotGraph", FluencyColdHotGraph)
Vue.component("FluencyGoalStatus", FluencyGoalStatus)
Vue.component("FluencyGradeButton", FluencyGradeButton)
Vue.component("FluencyReviewPage", FluencyReviewPage)
Vue.component("FluencyWpmGraph", FluencyWpmGraph)
// noinspection JSCheckFunctionSignatures
Vue.component("FreeSchoolTrialButton", FreeSchoolTrialButton)
Vue.component("FreeTrialForm", FreeTrialForm)
Vue.component("ConfirmationSent", ConfirmationSent)
Vue.component("GenerateReportPDFButton", GenerateReportPDFButton)
Vue.component("GenerateReportPdfButton", GenerateReportPDFButton) // FIXME: case mismatch in filename
Vue.component("HomeNavBar", HomeNavBar)
Vue.component("LeftyPopup", LeftyPopup)
Vue.component("ParentConnect", ParentConnect)
// noinspection JSCheckFunctionSignatures
Vue.component("ParentEmailManager", ParentEmailManager)
Vue.component("QuoteForm", QuoteForm);
Vue.component("PreviewExam", PreviewExam)
Vue.component("ProgressReportTable", ProgressReportTable)
Vue.component("ReportCriteriaSelector", ReportCriteriaSelector)
Vue.component("ReportGraph", ReportGraph)
Vue.component("ReviewExtension", ReviewExtension)
Vue.component("Sandbox", Sandbox)
Vue.component("SchoolAdminTeacherList", SchoolAdminTeacherList)
Vue.component("SearchStudents", SearchStudents)
Vue.component("SentryContext", SentryContext)
Vue.component("ShareEmailDialogButton", ShareEmailDialogButton)
Vue.component("SignupForm", SignupForm)
Vue.component("SocialLoginButtons", SocialLoginButtons)
Vue.component("StudentGroups", StudentGroups)
Vue.component("StudentList", StudentList)
Vue.component("StudentLogin", StudentLogin)
Vue.component("StudentReportLessonScoreTable", StudentReportLessonScoreTable)
Vue.component("TeacherEmailSummary", TeacherEmailSummary)
Vue.component("TeacherNavBar", TeacherNavBar)
Vue.component("VolumePricingBanner", VolumePricingBanner)
Vue.component("TeacherLogin", TeacherLogin)
// noinspection JSCheckFunctionSignatures
Vue.component("TeacherResources", TeacherResources)
Vue.component("TeacherSettings", TeacherSettings)
Vue.component("TutorialPopup", TutorialPopup)
Vue.component("TutorVideoCarousel", TutorVideoCarousel)
Vue.component("TeacherVideoPlayer", TeacherVideoPlayer)
Vue.component("VimeoPopout", VimeoPopout)
Vue.component("WithServices", WithServices)
Vue.component("WorksheetTable", WorksheetTable)

//// App initialization
initSentry()

Vue.config.devtools = true

const _ = new Vue({el: "#app"})

initInertia({layout: HomeLayout})
